import React from "react";
import { ENVIRONMENT } from "./utils/properties";
import Login from "./screens/Login/Login";
import RecoveryPassword from "./screens/Login/recoveryPassword/RecoveryPassword";
import ResetPassword from "./screens/Login/resetPassword/ResetPassword";
import { Outlet } from "react-router";
// Layout
import BasicLayout from "./layout/BasicLayout";
import NoMenuLayout from "./layout/NoMenuLayout";
// Screens
import Home from "./screens/Home/Home";
import Jobs from "./screens/Administration/Jobs/Jobs";
import Settings from "./screens/Administration/Settings/Settings";
import ProductCategories from "./screens/Administration/ProductCategories/ProductCategories";
import UserSuppliersList from "./screens/Administration/UserSuppliers/UserSuppliersList";
import UserSupplierDetail from "./screens/Administration/UserSuppliers/UserSupplierDetail";
import CostCenters from "./screens/Administration/ExpenseCenter/CostCenters";
import Projects from "./screens/Administration/Projects/Projects";
import ProjectsDetail from "./screens/Administration/Projects/ProjectsDetail";
import InternalUsersList from "./screens/Administration/UserInternal/InternalUsersList";
import InternalUserDetail from "./screens/Administration/UserInternal/InternalUserDetail";
import OdaAllocation from "./screens/SuppliersAdministration/OdaAllocation/OdaAllocation";
import OdaAllocationDetail from "./screens/SuppliersAdministration/OdaAllocation/OdaAllocationDetail";
import SalApproval from "./screens/SuppliersAdministration/SalApproval/SalApproval";
import SalApprovalDetail from "./screens/SuppliersAdministration/SalApproval/SalApprovalDetail";
import SalDeclaration from "./screens/SuppliersAdministration/SalDeclaration/SalDeclaration";
import SalDeclarationTabs from "./screens/SuppliersAdministration/SalDeclaration/SalDeclarationTabs";
import ChooseUser from "./screens/Master/ChooseUser";
import Report from "./screens/SuppliersAdministration/Report/Report";
import ExportSap from "./screens/Administration/ExportSap/ExportSap";
import ExportBpc from "./screens/Administration/ExportBpc/ExportBpc";
import ExportSF from "./screens/Administration/ExportSF/ExportSF";
import MonthPlanning from "./screens/Administration/MonthPlanning/MonthPlanning";
import Vertical from "./screens/Administration/Vertical/Vertical";
import SalesOrder from "./screens/Administration/SalesOrder/SalesOrder";
import Services from "./screens/Administration/Services/Services";
import Status from "./screens/Administration/Status/Status";
import WbsCategories from "./screens/Administration/WbsPhase/WbsCategories";
import WbsStructure from "./screens/Administration/WbsActivities/WbsStructure";
import Clients from "./screens/Administration/Clients/Clients";
import ClientsDetail from "./screens/Administration/Clients/ClientsDetail";
import ProjectEstimate from "./screens/ControlAndPianification/ProjectEstimate/ProjectEstimate";
import ProjectEstimateDetail from "./screens/ControlAndPianification/ProjectEstimate/ProjectEstimateDetail";
import ProjectsManagement from "./screens/ControlAndPianification/ProjectsManagement/ProjectsManagement";
import ProjectsManagementDetail from "./screens/ControlAndPianification/ProjectsManagement/ProjectsManagementDetail";
import ReportCP from "./screens/ControlAndPianification/ReportC&P/ReportCP";
import TimesheetUserList from "./screens/Timesheet/UsersTimesheet/TimesheetUserList";
import TimesheetDetail from "./screens/Timesheet/TimesheetDetail";
import TimesheetReportTabs from "./screens/Timesheet/Report/TimesheetReportTabs";
import TimesheetApproval from "./screens/Timesheet/TimesheetApproval/TimesheetApproval";
import TimesheetApprovalDetailRespCDC from "./screens/Timesheet/TimesheetApproval/TimesheetApprovalDetailRespCDC";
import TimesheetApprovalDetailPM from "./screens/Timesheet/TimesheetApproval/TimesheetApprovalDetailPM";
import ServiceRates from "./screens/Administration/ServiceRates/ServiceRates";
import ExportCostDetail from "./screens/Timesheet/Report/ExportCostDetail";
import CarFuelRefund from "./screens/ExpenseReportAdmin/CarFuelRefund";
import ExpenseAccountType from "./screens/ExpenseReportAdmin/ExpenseAccountType";
import CreditCard from "./screens/ExpenseReportAdmin/CreditCard";
import FuelCard from "./screens/ExpenseReportAdmin/FuelCard";
import ParkAuto from "./screens/ExpenseReportAdmin/ParkAuto";
import ParkAutoDetail from "./screens/ExpenseReportAdmin/ParkAutoDetail";
import ExpenseRefundFolder from "./screens/ExpenseReport/UserExpenseReport/ExpenseRefundFolder";
import ExpenseRefundFolderDetail from "./screens/ExpenseReport/UserExpenseReport/ExpenseRefundFolderDetail";
import FlatRateAmount from "./screens/ExpenseReportAdmin/FlatRateAmount";
import FlatRatePeriod from "./screens/ExpenseReportAdmin/FlatRatePeriod";
import FlatRateLocation from "./screens/ExpenseReportAdmin/FlatRateLocation";
import ApproveExpenseReport from "./screens/ExpenseReport/ApproveExpenseReport/ApproveExpenseReport";
import CarEngineType from "./screens/ExpenseReportAdmin/CarEngineType";
import ExportReport from "./screens/ExpenseReportAdmin/ExportReport";
import Setting from "./screens/Finance/Setting";
import Lg from "./screens/Finance/Lg";
import ReportLg from "./screens/Finance/ReportLg";
import DisapproveExpenseReport from "./screens/ExpenseReport/DisapproveExpenseReport/DisapproveExpenseReport";
import ExportDocuments from "./screens/ExpenseReportAdmin/ExportDocuments";

export default [
  {
    path: `${ENVIRONMENT.BASE_URL}login`,
    element: <Outlet />,
    children: [{ index: true, element: <Login /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}`,
    element: (
      <BasicLayout
        path={`${ENVIRONMENT.BASE_URL}`}
        isCustom={false}
        name={""}
        haveBreadcrumb={false}
        haveTitle={false}
      />
    ),
    children: [{ index: true, element: <Home /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}jobs`,
    element: <BasicLayout isCustom={false} name={"menuLeft.jobs"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Jobs /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}settings`,
    element: <BasicLayout isCustom={false} name={"menuLeft.settings"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Settings /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}product-categories`,
    element: (
      <BasicLayout isCustom={false} name={"menuLeft.productCategories"} haveBreadcrumb={true} haveTitle={true} />
    ),
    children: [{ index: true, element: <ProductCategories /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}user-suppliers`,
    element: <BasicLayout isCustom={false} name={"menuLeft.userSuppliers"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <UserSuppliersList /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}user-suppliers/:supplierUsername`,
    element: (
      <BasicLayout
        isCustom={true}
        name={"menuLeft.userSuppliers"}
        haveBreadcrumb={true}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}user-suppliers`}
      />
    ),
    children: [{ index: true, element: <UserSupplierDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}internal-users`,
    element: <BasicLayout isCustom={false} name={"menuLeft.internalUsers"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <InternalUsersList /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}internal-users/:internalUsername`,
    element: (
      <BasicLayout
        isCustom={true}
        name={"menuLeft.internalUsers"}
        haveBreadcrumb={true}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}internal-users`}
      />
    ),
    children: [{ index: true, element: <InternalUserDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}clients`,
    element: <BasicLayout isCustom={false} name={"menuLeft.clients"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Clients /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}clients`,
    element: <BasicLayout isCustom={false} name={"menuLeft.clients"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Clients /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}clients/:id`,
    element: (
      <BasicLayout
        isCustom={true}
        name={"menuLeft.clients"}
        haveBreadcrumb={true}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}clients`}
      />
    ),
    children: [{ index: true, element: <ClientsDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}expense-centers`,
    element: <BasicLayout isCustom={false} name={"menuLeft.expenseCenters"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <CostCenters /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}projects`,
    element: <BasicLayout isCustom={false} name={"menuLeft.projects"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Projects /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}projects/:id`,
    element: (
      <BasicLayout
        isCustom={true}
        name={"menuLeft.projects"}
        haveBreadcrumb={true}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}projects`}
      />
    ),
    children: [{ index: true, element: <ProjectsDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}oda-allocation`,
    element: <BasicLayout isCustom={false} name={"menuLeft.odaAllocation"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <OdaAllocation /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}oda-allocation/:supplierId`,
    element: (
      <BasicLayout
        isCustom={true}
        name={"menuLeft.odaAllocation"}
        haveBreadcrumb={true}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}oda-allocation`}
      />
    ),
    children: [{ index: true, element: <OdaAllocationDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}sal-declaration`,
    element: <BasicLayout isCustom={false} name={"menuLeft.salDeclaration"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <SalDeclaration /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}sal-declaration/:id`,
    element: (
      <BasicLayout
        isCustom={true}
        name={"menuLeft.salDeclaration"}
        haveBreadcrumb={true}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}sal-declaration`}
      />
    ),
    children: [{ index: true, element: <SalDeclarationTabs /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}sal-approval`,
    element: <BasicLayout isCustom={false} name={"menuLeft.salApproval"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <SalApproval /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}sal-approval/:supplierId`,
    element: (
      <BasicLayout
        isCustom={true}
        name={"menuLeft.salApproval"}
        haveBreadcrumb={true}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}sal-approval`}
      />
    ),
    children: [{ index: true, element: <SalApprovalDetail /> }],
  },

  {
    path: `${ENVIRONMENT.BASE_URL}choose-user`,
    element: <NoMenuLayout isCustom={false} name={"chooseUser.title"} haveBreadcrumb={false} haveTitle={true} />,
    children: [{ index: true, element: <ChooseUser /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}report`,
    element: <BasicLayout isCustom={false} name={"menuLeft.report"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Report /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}export-sap`,
    element: <BasicLayout isCustom={false} name={"menuLeft.exportSap"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ExportSap /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}export-bpc`,
    element: <BasicLayout isCustom={false} name={"menuLeft.exportBpc"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ExportBpc /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}export-sf`,
    element: <BasicLayout isCustom={false} name={"menuLeft.exportSf"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ExportSF /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}month-planning`,
    element: <BasicLayout isCustom={false} name={"menuLeft.monthPlanning"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <MonthPlanning /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}recovery-password`,
    element: (
      <NoMenuLayout
        isCustom={false}
        name={"recoveryPassword.backTitle"}
        haveBreadcrumb={false}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}login`}
      />
    ),
    children: [{ index: true, element: <RecoveryPassword /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}reset-password`,
    element: (
      <NoMenuLayout
        isCustom={false}
        name={"resetPassword.backTitle"}
        haveBreadcrumb={false}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}login`}
      />
    ),
    children: [{ index: true, element: <ResetPassword /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}vertical`,
    element: <BasicLayout isCustom={false} name={"menuLeft.vertical"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Vertical /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}sales-order`,
    element: <BasicLayout isCustom={false} name={"menuLeft.salesOrder"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <SalesOrder /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}services`,
    element: <BasicLayout isCustom={false} name={"menuLeft.services"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Services /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}service-rates`,
    element: <BasicLayout isCustom={false} name={"menuLeft.serviceRates"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ServiceRates /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}status`,
    element: <BasicLayout isCustom={false} name={"menuLeft.status"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Status /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}wbs-categories`,
    element: <BasicLayout isCustom={false} name={"menuLeft.wbsCategories"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <WbsCategories /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}wbs-structure`,
    element: <BasicLayout isCustom={false} name={"menuLeft.wbsStructure"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <WbsStructure /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}project-estimate`,
    element: <BasicLayout isCustom={false} name={"menuLeft.projectEstimate"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ProjectEstimate /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}project-estimate/:id`,
    element: (
      <BasicLayout
        haveBack={true}
        backUrl={"/project-estimate"}
        isCustom={true}
        name={"menuLeft.projectEstimate"}
        haveBreadcrumb={true}
        haveTitle={true}
      />
    ),
    children: [{ index: true, element: <ProjectEstimateDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}projects-management`,
    element: (
      <BasicLayout isCustom={false} name={"menuLeft.projectsManagement"} haveBreadcrumb={true} haveTitle={true} />
    ),
    children: [{ index: true, element: <ProjectsManagement /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}projects-management/:id`,
    element: (
      <BasicLayout
        haveBack={true}
        backUrl={"/projects-management"}
        isCustom={true}
        name={"menuLeft.projectsManagement"}
        haveBreadcrumb={true}
        haveTitle={true}
      />
    ),
    children: [{ index: true, element: <ProjectsManagementDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}report-CP`,
    element: <BasicLayout isCustom={false} name={"menuLeft.reportCp"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ReportCP /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}personal-timesheet`,
    element: (
      <BasicLayout isCustom={false} name={"menuLeft.personalTimesheet"} haveBreadcrumb={true} haveTitle={true} />
    ),
    children: [{ index: true, element: <TimesheetDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}timesheet`,
    element: <BasicLayout isCustom={false} name={"menuLeft.timesheetUser"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <TimesheetUserList /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}timesheet/:id`,
    element: (
      <BasicLayout
        haveBack={true}
        backUrl={"/timesheet"}
        isCustom={true}
        name={"menuLeft.timesheet"}
        haveBreadcrumb={true}
        haveTitle={true}
      />
    ),
    children: [{ index: true, element: <TimesheetDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}timesheet-approval`,
    element: (
      <BasicLayout isCustom={false} name={"menuLeft.timesheetApproval"} haveBreadcrumb={true} haveTitle={true} />
    ),
    children: [{ index: true, element: <TimesheetApproval /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}timesheet-approval/resp-cdc/:id`,
    element: (
      <BasicLayout
        haveBack={true}
        backUrl={"/timesheet-approval"}
        isCustom={true}
        name={"menuLeft.timesheetApproval"}
        haveBreadcrumb={true}
        haveTitle={true}
      />
    ),
    children: [{ index: true, element: <TimesheetApprovalDetailRespCDC /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}timesheet-approval/pm/:id`,
    element: (
      <BasicLayout
        haveBack={true}
        backUrl={"/timesheet-approval"}
        isCustom={true}
        name={"menuLeft.timesheetApproval"}
        haveBreadcrumb={true}
        haveTitle={true}
      />
    ),
    children: [{ index: true, element: <TimesheetApprovalDetailPM /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}timesheet/report`,
    element: <BasicLayout isCustom={false} name={"menuLeft.report"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <TimesheetReportTabs /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}timesheet-export`,
    element: <BasicLayout isCustom={false} name={"menuLeft.timesheetExport"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ExportCostDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}car-fuel-refund`,
    element: <BasicLayout isCustom={false} name={"menuLeft.carFuelRefund"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <CarFuelRefund /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}expense-account-type`,
    element: (
      <BasicLayout isCustom={false} name={"menuLeft.expenseAccountType"} haveBreadcrumb={true} haveTitle={true} />
    ),
    children: [{ index: true, element: <ExpenseAccountType /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}credit-card`,
    element: <BasicLayout isCustom={false} name={"menuLeft.creditCard"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <CreditCard /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}fuel-card`,
    element: <BasicLayout isCustom={false} name={"menuLeft.fuelCard"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <FuelCard /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}car-engine-type`,
    element: <BasicLayout isCustom={false} name={"menuLeft.carEngineType"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <CarEngineType /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}park-auto`,
    element: <BasicLayout isCustom={false} name={"menuLeft.parkAuto"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ParkAuto /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}park-auto/:carId`,
    element: (
      <BasicLayout
        isCustom={true}
        name={"menuLeft.parkAuto"}
        haveBreadcrumb={true}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}park-auto`}
      />
    ),
    children: [{ index: true, element: <ParkAutoDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}flat-rate-amount`,
    element: <BasicLayout isCustom={false} name={"menuLeft.flatRateAmount"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <FlatRateAmount /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}flat-rate-period`,
    element: <BasicLayout isCustom={false} name={"menuLeft.flatRatePeriod"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <FlatRatePeriod /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}flat-rate-location`,
    element: <BasicLayout isCustom={false} name={"menuLeft.flatRateLocation"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <FlatRateLocation /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}expense-refund-folder`,
    element: (
      <BasicLayout isCustom={false} name={"menuLeft.expenseRefundFolder"} haveBreadcrumb={true} haveTitle={true} />
    ),
    children: [{ index: true, element: <ExpenseRefundFolder /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}expense-refund-folder-users`,
    element: (
      <BasicLayout isCustom={false} name={"menuLeft.expenseRefundFolderUsers"} haveBreadcrumb={true} haveTitle={true} />
    ),
    children: [{ index: true, element: <ExpenseRefundFolder showAll /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}expense-refund-folder/:folderId`,
    element: (
      <BasicLayout
        isCustom={true}
        name={"menuLeft.expenseRefundFolder"}
        haveBreadcrumb={true}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}expense-refund-folder`}
      />
    ),
    children: [{ index: true, element: <ExpenseRefundFolderDetail /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}expense-refund-folder-users/:folderId`,
    element: (
      <BasicLayout
        isCustom={true}
        name={"menuLeft.expenseRefundFolder"}
        haveBreadcrumb={true}
        haveTitle={true}
        haveBack={true}
        backUrl={`${ENVIRONMENT.BASE_URL}expense-refund-folder-users`}
      />
    ),
    children: [{ index: true, element: <ExpenseRefundFolderDetail showAll /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}approve-expense-report`,
    element: (
      <BasicLayout isCustom={false} name={"menuLeft.approveExpenseReport"} haveBreadcrumb={true} haveTitle={true} />
    ),
    children: [{ index: true, element: <ApproveExpenseReport /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}disapprove-expense-report`,
    element: (
      <BasicLayout isCustom={false} name={"menuLeft.disapproveExpenseReport"} haveBreadcrumb={true} haveTitle={true} />
    ),
    children: [{ index: true, element: <DisapproveExpenseReport /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}export-report`,
    element: <BasicLayout isCustom={false} name={"menuLeft.exportReport"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ExportReport /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}export-documents`,
    element: <BasicLayout isCustom={false} name={"menuLeft.exportDocuments"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ExportDocuments /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}setting-lg`,
    element: <BasicLayout isCustom={false} name={"menuLeft.settingLg"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Setting /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}lg`,
    element: <BasicLayout isCustom={false} name={"menuLeft.lg"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <Lg /> }],
  },
  {
    path: `${ENVIRONMENT.BASE_URL}report-lg`,
    element: <BasicLayout isCustom={false} name={"menuLeft.reportLg"} haveBreadcrumb={true} haveTitle={true} />,
    children: [{ index: true, element: <ReportLg /> }],
  },
  {
    path: "*",
    element: <>Page not found</>,
  },
];
